export default __webpack_public_path__ + "static/media/support-icon.a66c70d7.svg";